import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { ErrorDialogComponent } from 'src/app/Shared/shared/error-dialog/error-dialog.component';
import alertify from "alertifyjs";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-verification-result',
  templateUrl: './verification-result.component.html',
  styleUrls: ['./verification-result.component.css']
})
export class VerificationResultComponent implements OnInit{
  isLoading: boolean;
  details: any;
  form: any = FormGroup;


  constructor(private router: Router, private route: ActivatedRoute, 
    private apiService: ApiServiceService,  private bsModalService: BsModalService, 
    private fb: FormBuilder) {
}



ngOnInit(): void {

this.isLoading = true;

this.onload()


this.form = this.fb.group({

  verificationType: ['', [Validators.required]],
  id: ['', [Validators.required]],

});



}


onload(){
  const snapshot = this.route.snapshot;

  const type = snapshot.params['type']
  const id = snapshot.params['id']

  this.verify(type, id)

}

submit() {

  this.isLoading = true

  const type: string = this.form.get("verificationType")?.value
  const id: string = this.form.get("id")?.value

  const dto = {
    id: id,
    type: type
  }
  
    const url = '/assessments/document/verifications';
  
  
    this.details = {}
  
  
    this.apiService.post(url, dto).subscribe(
    (response) => {

      if (response?.data != null) {

        this.details = response?.data;

        this.isLoading = false

      } 

      if(this.details.message == 'Not Found!'){

        this.confirmAfterError('Not Found!');

      }
    },
    (error) => {
      this.isLoading = false
      this.confirmAfterError("Action was not successful");
      alertify.set("notifier", "position", "top-center");
      alertify.error("Error performing this operation");

    }
  );

}


verify(type: string, id: string){


  const dto = {
    id: id,
    type: type
  }
  
    const url = '/assessments/document/verifications';
  
  
    this.details = {}
  
  
    this.apiService.post(url, dto).subscribe(
    (response) => {

      this.isLoading = false

      if (response?.data != null) {

        this.details = response?.data;

      } else {

        this.isLoading = false
      }

      if(this.details.message == 'Not Found!'){

        this.confirmAfterError('Not Found!');

      }
    },
    (error) => {
      this.isLoading = false
      this.confirmAfterError("Action was not successful");
      alertify.set("notifier", "position", "top-center");
      alertify.error("Error performing this operation");

    }
  );




}

confirmAfterError(message: any) {
  let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
    initialState: {
      body: message,
    },
    class: "modal-sm modal-dialog-centered",
  });
  dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
    dfModalRef.hide();
  });
}

}


